import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterceptorUtil, OCC_USER_ID_ANONYMOUS, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ArticleReferences } from '../../../../../core/model';

@Injectable({ providedIn: 'root' })
export class CmsFeaturedArticlesConnector {
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  /**
   * Get featuredArticlesReferences from api
   * @param userId the user id
   * @param uid the component id
   */
  getFeaturedArticlesReferences(userId: string, uid: string): Observable<ArticleReferences> {
    let headers = new HttpHeaders();
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    return this.httpClient.get<ArticleReferences>(
      this.occEndpointsService.buildUrl('featuredArticles', {
        urlParams: {
          userId,
        },
        queryParams: {
          uid: uid,
        },
      }),
      { headers }
    );
  }
}
